import React, { useState, useEffect, useRef } from 'react';
import { NEWS } from '../data/siteData';

export default function News() {
  const [filter, setFilter] = useState('All');
  const cats = ['All', ...new Set(NEWS.map((n) => n.cat))];

  const filtered = filter === 'All' ? NEWS : NEWS.filter((n) => n.cat === filter);

  const sectionRef = useRef(null);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          el.querySelectorAll('.rv, .rl, .rr, .rs').forEach((n) => n.classList.add('on'));
          obs.unobserve(el);
        }
      },
      { threshold: 0.07 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="news-sec" id="news" ref={sectionRef} aria-labelledby="news-heading">
      <div className="wrap">
        <div className="sec-split">
          {/* Left: heading */}
          <div className="rl">
            <div className="chip" style={{ marginBottom: '.8rem' }}>📰 Press & News</div>
            <h2 id="news-heading" style={{ fontSize: 'clamp(1.8rem,2.8vw,2.4rem)', fontWeight: 900, letterSpacing: '-.04em', margin: '.35rem 0 .65rem' }}>
              Latest Updates
            </h2>
            <p style={{ color: 'var(--body)', lineHeight: 1.8, marginBottom: '1.5rem', maxWidth: 320 }}>
              Product launches, company milestones, and technology insights from the JSDevBrains team.
            </p>

            {/* Filter pills */}
            <div className="nf-row" role="group" aria-label="News category filter">
              {cats.map((cat) => (
                <button
                  key={cat}
                  className={`nf${filter === cat ? ' on' : ''}`}
                  onClick={() => setFilter(cat)}
                  aria-pressed={filter === cat}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          {/* Right: cards */}
          <div className="news-cards rr">
            {filtered.map((item) => (
              <article className="nc" key={item.title}>
                <div className="nc-cat" style={{ background: item.catBg, color: item.catColor }}>
                  {item.cat}
                </div>
                <div className="nc-date">{item.date}</div>
                <h3 className="nc-title">{item.title}</h3>
                <p className="nc-desc">{item.desc}</p>
                <a href="#contact" className="nc-more" onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}>
                  Read More →
                </a>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
